<template>
    <div class="asidepart">
        <div class="asideTop">
            <div class="asideItem ag">
                <div class="asideImage">
                    <img :src="$Localimg('as1.png')" alt="" />
                </div>
                <div class="asideword">
                    关注公众号
                </div>

                <div class="alers ga">
                    <img :src="$img(gzh)" alt="" />
                </div>

            </div>
            <div class="asideItem ax">
                <div class="asideImage">
                    <img :src="$Localimg('as2.png')" alt="" />
                </div>
                <div class="asideword">
                    官方小程序
                </div>
                <div class="alers xa">
                    <img :src="$img(xcx)" alt="" />
                </div>
            </div>
           <div class="asideItem" @click="tocus">
                <div class="asideImage">
                    <img :src="$Localimg('as3.png')" alt="" />
                </div>
                <div class="asideword">
                    在线客服
                </div>
            </div>
        </div>

        <div class="asideItem" style="border: 1px solid #E8E8F2;margin-top: 12px;border-radius: 10px;" @click="totop">
            <div class="asideImage">
                <img :src="$Localimg('as4.png')" alt="" />
            </div>
            <div class="asideword">
                回到顶部
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getConfig
    } from "@/api/index.js"

    import {
        eventBus
    } from '../App.vue'
    export default {
        name: 'asidepart',
        data() {
            return {
                gzh: "",
                xcx: ""
            }
        },
        created() {
            getConfig().then((res) => {
                console.log('aside', res)
                if (res.code == 1) {
                    this.gzh = res.data.gzh_qrcode
                    this.xcx = res.data.xcx_qrcode
                }
            })
        },
        methods: {
            tocus() {
                this.$ysf('open')
            },
            totop() {
                this.$emit('scrolltop')
            }
        }
    }
</script>

<style scoped>
    .ag:hover .ga {
        display: block !important;
    }

    .ax:hover .xa {
        display: block !important;
    }

    .alers {
        width: 100px;
        height: 100px;
        box-sizing: border-box;
        padding: 8px;
        border-radius: 10px;
        position: absolute;
        left: -100px;
        top: 0;
        background: #fff;
        display: none;
    }

    .alers img {
        width: 100%;
        height: 100%;
    }

    .asidepart {
        position: fixed;
        right: 12px;
        bottom: 100px;
        z-index: 79988 !important;
    }

    .asideTop {
        border-radius: 10px;
        border: 1px solid #E8E8F2;
        /* overflow: hidden */
    }

    .asideItem {
        width: 100px;
        height: 100px;
        text-align: center;
        box-sizing: border-box;
        padding-top: 16px;
        background: #fff;
        cursor: pointer;
        position: relative;
    }

    .asideItem:first-child {
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }

    .asideItem:last-child {
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .asideImage {
        width: 30px;
        height: 30px;
        margin: 0 auto 4px;
    }

    .asideImage img {
        width: 100%;
        height: 100%;
    }

    .asideword {
        font-size: 12px;
        color: #4C5164;
        line-height: 21px;
    }
</style>